import { Component, Input, OnChanges } from '@angular/core';
import { Store } from '@ngneat/elf';

@Component({
    selector: 'app-single-load-plot',
    template: `
    <app-xy-line-plot
      [plotData]="plot.data"
      [xAxisTitle]="xAxisTitle"
      [yAxisTitle]="yAxisTitle"
      [plotName]="plotName"
      [downloadPlotName]="downloadPlotName"
      [plotTitle]="plotTitle"
      [componentHeight]="componentHeight"
      [xyLinePlotStore]="singleLoadPlotStore"
    ></app-xy-line-plot>
  `,
    styles: [':host { display: flex; flex-direction: column; height: 100%; overflow: hidden; flex: 1 1 0%; min-height: 0; } :host([hidden]) { display: none !important; }'],
    standalone: false
})
export class SingleLoadPlotComponent implements OnChanges {
  @Input() yAxisTitle = '';
  @Input() xAxisTitle = '';
  @Input() columnDefs: any[];
  @Input() loadCaseResultField = '';
  @Input() data: any[];
  @Input() selectedDepthView = 'md';
  @Input() depthUnit = 'ft';
  @Input() plotName = '';
  @Input() plotTitle = '';
  @Input() toolbarHeight = 0;
  @Input() componentHeight: number;
  @Input() singleLoadPlotStore: Store;

  configMissing: boolean;

  public downloadPlotName = 'load_results_plot';
  public plot = {
    data: [],
    layout: {
      xaxis: {
        autorange: true
      },
      yaxis: {
        autorange: 'reversed'
      }
    },
    config: {
      scrollZoom: false
    }
  };

  ngOnChanges(): void {
    this.parseResults(this.data);
    this.resetAxes();
  }

  private resetAxes(): void {
    this.plot.layout.xaxis.autorange = true;
    this.plot.layout.yaxis.autorange = 'reversed';
  }

  private parseResults(results: any[]) {
    if (results === undefined) { return; }
    this.plot.config.scrollZoom = this.plot ? true : false;
    const traceArray = [];

    let count = 0;
    this.columnDefs?.forEach((element => {
      const isDesignFactorOrSinusoidalBuckling = element.header == 'Critical Holliday Stress Ratio' || element.header.slice(-2) === 'DF' || element.header.slice(-6) === 'Rating' ||
       (this.plotTitle == 'Buckling Summary' && element.header.startsWith('Sinusoidal Buckling Load'));
      const isHelicalBuckling = this.plotTitle == 'Buckling Summary' && element.header.startsWith('Helical Buckling Load');
      const lineTypes = ['dot', 'dash', 'longdash', 'dashdot', 'longdashdot'];
      traceArray.push(
        {
          name: element.header,
          x: results.map(r => this.getValue(r[element.field])),
          y: this.selectedDepthView === 'md' ? results.map(r => r.measuredDepth) : results.map(r => r.trueVerticalDepth),
          mode: 'lines',
          line: {
            dash: isDesignFactorOrSinusoidalBuckling ? 'dot' : count > 8 ? lineTypes[(count - 9) % lineTypes.length] : 'solid',
            width: isDesignFactorOrSinusoidalBuckling ? 4 : 1.5,
            color: isDesignFactorOrSinusoidalBuckling || isHelicalBuckling ? 'red' : element.color
          }
        });
      count++;
    }));

    this.plot.data = traceArray;
    this.yAxisTitle = this.selectedDepthView === 'md' ? `MD (${this.depthUnit})` : `TVD (${this.depthUnit})`;
  }

  private getValue(e: string) {
    if (e?.toString().slice(- 1) == '*') {
      return +e.substring(0, e.length - 2);
    }

    return e;
  }
}
